export type TenantCountry = 'ARGENTINA' | 'URUGUAY';

export function normalizeTenantCountry(country?: string | null): TenantCountry {
  const value = typeof country === 'string' ? country.trim().toUpperCase() : '';
  if (value === 'URUGUAY') return 'URUGUAY';
  if (value === 'ARGENTINA') return 'ARGENTINA';

  const reason = value
    ? `Unknown tenant country "${country}"`
    : 'Missing tenant country';
  console.warn(`[countryConfig] ${reason}, falling back to ARGENTINA`);
  return 'ARGENTINA';
}

export function isUruguayCountry(country: TenantCountry): boolean {
  return country === 'URUGUAY';
}

/**
 * Strict allowlist for Argentina-only bureaus (NOSIS/CASFOG/BCRA debt paths).
 * Unknown / missing / third-country must NOT inherit NOSIS via normalize fallback.
 */
export function isArgentinaCountry(country?: string | null): boolean {
  return typeof country === 'string' && country.trim().toUpperCase() === 'ARGENTINA';
}
